const setWhoIsToPlay = (whoIsToPlay) => {
  return { type: "SET_WHO_IS_TO_PLAY", payload: whoIsToPlay };
};

export default setWhoIsToPlay;
